export const USER_PACKAGE_STATUS = {
  RUNNING: 'RUNNING',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
};
